// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Duplicate Detection Modal Styles */

.duplicate-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: duplicateModalFadeIn 0.3s ease-out;
}

.duplicate-modal-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25), 
              0 0 0 1px rgba(0, 0, 0, 0.05);
  max-width: 520px;
  width: 90%;
  max-height: 90vh;
  overflow: hidden;
  animation: duplicateModalSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  position: relative;
}

/* Header */
.duplicate-modal-header {
  padding: 32px 32px 24px 32px;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border-bottom: 1px solid #f3f4f6;
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.duplicate-modal-icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  background: rgba(245, 158, 11, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4px;
}

.duplicate-modal-title h3 {
  margin: 0 0 8px 0;
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.3;
}

.duplicate-modal-subtitle {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.4;
}

/* Content */
.duplicate-modal-content {
  padding: 24px 32px;
  max-height: 60vh;
  overflow-y: auto;
}

.duplicate-files-list {
  margin-bottom: 24px;
}

.duplicate-file-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-bottom: 8px;
  transition: all 0.2s ease;
}

.duplicate-file-item:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}

.duplicate-file-item:last-child {
  margin-bottom: 0;
}

.duplicate-file-icon {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  background: white;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e7eb;
}

.duplicate-file-name {
  flex: 1 1;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  word-break: break-all;
  line-height: 1.4;
}

.duplicate-file-status {
  flex-shrink: 0;
}

.duplicate-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  background: #fef2f2;
  color: #dc2626;
  font-size: 12px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #fecaca;
}

.duplicate-modal-message {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 20px;
  margin-top: 16px;
}

.duplicate-modal-message p {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #475569;
  font-weight: 500;
}

.duplicate-options-list {
  margin: 0;
  padding-left: 0;
  list-style: none;
}

.duplicate-options-list li {
  margin: 8px 0;
  padding-left: 20px;
  font-size: 14px;
  color: #64748b;
  line-height: 1.5;
  position: relative;
}

.duplicate-options-list li::before {
  content: '•';
  color: #3b82f6;
  font-weight: bold;
  position: absolute;
  left: 8px;
}

.duplicate-options-list li strong {
  color: #1e293b;
  font-weight: 600;
}

/* Footer */
.duplicate-modal-footer {
  padding: 24px 32px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.duplicate-btn-secondary,
.duplicate-btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  min-height: 40px;
}

.duplicate-btn-secondary {
  background: white;
  color: #6b7280;
  border: 1px solid #d1d5db;
}

.duplicate-btn-secondary:hover {
  background: #f9fafb;
  border-color: #9ca3af;
  color: #4b5563;
}

.duplicate-btn-primary {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  border: 1px solid #2563eb;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.duplicate-btn-primary:hover {
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
  border-color: #1d4ed8;
  box-shadow: 0 4px 12px 0 rgba(59, 130, 246, 0.3);
  transform: translateY(-1px);
}

.duplicate-btn-primary:active {
  transform: translateY(0);
}

/* Animations */
@keyframes duplicateModalFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes duplicateModalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 640px) {
  .duplicate-modal-container {
    width: 95%;
    margin: 20px;
    max-height: calc(100vh - 40px);
  }

  .duplicate-modal-header {
    padding: 24px 20px 20px 20px;
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }

  .duplicate-modal-content {
    padding: 20px;
  }

  .duplicate-modal-footer {
    padding: 20px;
    flex-direction: column-reverse;
  }

  .duplicate-btn-secondary,
  .duplicate-btn-primary {
    width: 100%;
    justify-content: center;
  }

  .duplicate-modal-title h3 {
    font-size: 18px;
  }

  .duplicate-file-item {
    padding: 10px 12px;
  }

  .duplicate-file-name {
    font-size: 13px;
  }
}

/* Dark mode support (if your app uses it) */
@media (prefers-color-scheme: dark) {
  .duplicate-modal-container {
    background: #1f2937;
    color: #f9fafb;
  }

  .duplicate-modal-header {
    background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
    border-bottom-color: #374151;
  }

  .duplicate-modal-title h3 {
    color: #f9fafb;
  }

  .duplicate-modal-subtitle {
    color: #d1d5db;
  }

  .duplicate-file-item {
    background: #374151;
    border-color: #4b5563;
  }

  .duplicate-file-item:hover {
    background: #4b5563;
    border-color: #6b7280;
  }

  .duplicate-file-icon {
    background: #4b5563;
    border-color: #6b7280;
  }

  .duplicate-file-name {
    color: #e5e7eb;
  }

  .duplicate-modal-message {
    background: #374151;
    border-color: #4b5563;
  }

  .duplicate-modal-message p {
    color: #d1d5db;
  }

  .duplicate-options-list li {
    color: #9ca3af;
  }

  .duplicate-options-list li strong {
    color: #e5e7eb;
  }

  .duplicate-modal-footer {
    background: #374151;
    border-top-color: #4b5563;
  }

  .duplicate-btn-secondary {
    background: #4b5563;
    color: #d1d5db;
    border-color: #6b7280;
  }

  .duplicate-btn-secondary:hover {
    background: #6b7280;
    border-color: #9ca3af;
    color: #f3f4f6;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/DuplicateDetectionModal.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB;2CACyC;EACzC,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,uEAAuE;EACvE,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,4BAA4B;EAC5B,6DAA6D;EAC7D,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;IAC5B,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,6DAA6D;IAC7D,4BAA4B;EAC9B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;AACF","sourcesContent":["/* Duplicate Detection Modal Styles */\n\n.duplicate-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: duplicateModalFadeIn 0.3s ease-out;\n}\n\n.duplicate-modal-container {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25), \n              0 0 0 1px rgba(0, 0, 0, 0.05);\n  max-width: 520px;\n  width: 90%;\n  max-height: 90vh;\n  overflow: hidden;\n  animation: duplicateModalSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n  position: relative;\n}\n\n/* Header */\n.duplicate-modal-header {\n  padding: 32px 32px 24px 32px;\n  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);\n  border-bottom: 1px solid #f3f4f6;\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.duplicate-modal-icon {\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  background: rgba(245, 158, 11, 0.1);\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 4px;\n}\n\n.duplicate-modal-title h3 {\n  margin: 0 0 8px 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #1f2937;\n  line-height: 1.3;\n}\n\n.duplicate-modal-subtitle {\n  margin: 0;\n  font-size: 14px;\n  color: #6b7280;\n  line-height: 1.4;\n}\n\n/* Content */\n.duplicate-modal-content {\n  padding: 24px 32px;\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n.duplicate-files-list {\n  margin-bottom: 24px;\n}\n\n.duplicate-file-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  transition: all 0.2s ease;\n}\n\n.duplicate-file-item:hover {\n  background: #f3f4f6;\n  border-color: #d1d5db;\n}\n\n.duplicate-file-item:last-child {\n  margin-bottom: 0;\n}\n\n.duplicate-file-icon {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  background: white;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #e5e7eb;\n}\n\n.duplicate-file-name {\n  flex: 1;\n  font-size: 14px;\n  font-weight: 500;\n  color: #374151;\n  word-break: break-all;\n  line-height: 1.4;\n}\n\n.duplicate-file-status {\n  flex-shrink: 0;\n}\n\n.duplicate-status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 8px;\n  background: #fef2f2;\n  color: #dc2626;\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #fecaca;\n}\n\n.duplicate-modal-message {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 20px;\n  margin-top: 16px;\n}\n\n.duplicate-modal-message p {\n  margin: 0 0 12px 0;\n  font-size: 14px;\n  color: #475569;\n  font-weight: 500;\n}\n\n.duplicate-options-list {\n  margin: 0;\n  padding-left: 0;\n  list-style: none;\n}\n\n.duplicate-options-list li {\n  margin: 8px 0;\n  padding-left: 20px;\n  font-size: 14px;\n  color: #64748b;\n  line-height: 1.5;\n  position: relative;\n}\n\n.duplicate-options-list li::before {\n  content: '•';\n  color: #3b82f6;\n  font-weight: bold;\n  position: absolute;\n  left: 8px;\n}\n\n.duplicate-options-list li strong {\n  color: #1e293b;\n  font-weight: 600;\n}\n\n/* Footer */\n.duplicate-modal-footer {\n  padding: 24px 32px;\n  background: #f8fafc;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.duplicate-btn-secondary,\n.duplicate-btn-primary {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-decoration: none;\n  min-height: 40px;\n}\n\n.duplicate-btn-secondary {\n  background: white;\n  color: #6b7280;\n  border: 1px solid #d1d5db;\n}\n\n.duplicate-btn-secondary:hover {\n  background: #f9fafb;\n  border-color: #9ca3af;\n  color: #4b5563;\n}\n\n.duplicate-btn-primary {\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  color: white;\n  border: 1px solid #2563eb;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.duplicate-btn-primary:hover {\n  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);\n  border-color: #1d4ed8;\n  box-shadow: 0 4px 12px 0 rgba(59, 130, 246, 0.3);\n  transform: translateY(-1px);\n}\n\n.duplicate-btn-primary:active {\n  transform: translateY(0);\n}\n\n/* Animations */\n@keyframes duplicateModalFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes duplicateModalSlideIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9) translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 640px) {\n  .duplicate-modal-container {\n    width: 95%;\n    margin: 20px;\n    max-height: calc(100vh - 40px);\n  }\n\n  .duplicate-modal-header {\n    padding: 24px 20px 20px 20px;\n    flex-direction: column;\n    text-align: center;\n    gap: 12px;\n  }\n\n  .duplicate-modal-content {\n    padding: 20px;\n  }\n\n  .duplicate-modal-footer {\n    padding: 20px;\n    flex-direction: column-reverse;\n  }\n\n  .duplicate-btn-secondary,\n  .duplicate-btn-primary {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .duplicate-modal-title h3 {\n    font-size: 18px;\n  }\n\n  .duplicate-file-item {\n    padding: 10px 12px;\n  }\n\n  .duplicate-file-name {\n    font-size: 13px;\n  }\n}\n\n/* Dark mode support (if your app uses it) */\n@media (prefers-color-scheme: dark) {\n  .duplicate-modal-container {\n    background: #1f2937;\n    color: #f9fafb;\n  }\n\n  .duplicate-modal-header {\n    background: linear-gradient(135deg, #374151 0%, #4b5563 100%);\n    border-bottom-color: #374151;\n  }\n\n  .duplicate-modal-title h3 {\n    color: #f9fafb;\n  }\n\n  .duplicate-modal-subtitle {\n    color: #d1d5db;\n  }\n\n  .duplicate-file-item {\n    background: #374151;\n    border-color: #4b5563;\n  }\n\n  .duplicate-file-item:hover {\n    background: #4b5563;\n    border-color: #6b7280;\n  }\n\n  .duplicate-file-icon {\n    background: #4b5563;\n    border-color: #6b7280;\n  }\n\n  .duplicate-file-name {\n    color: #e5e7eb;\n  }\n\n  .duplicate-modal-message {\n    background: #374151;\n    border-color: #4b5563;\n  }\n\n  .duplicate-modal-message p {\n    color: #d1d5db;\n  }\n\n  .duplicate-options-list li {\n    color: #9ca3af;\n  }\n\n  .duplicate-options-list li strong {\n    color: #e5e7eb;\n  }\n\n  .duplicate-modal-footer {\n    background: #374151;\n    border-top-color: #4b5563;\n  }\n\n  .duplicate-btn-secondary {\n    background: #4b5563;\n    color: #d1d5db;\n    border-color: #6b7280;\n  }\n\n  .duplicate-btn-secondary:hover {\n    background: #6b7280;\n    border-color: #9ca3af;\n    color: #f3f4f6;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
